export const CHANGE_VOLUME:'CHANGE_VOLUME' = 'CHANGE_VOLUME';
export const CHANGE_VOLUME_CONTROLBAR:'CHANGE_VOLUME_CONTROLBAR' = 'CHANGE_VOLUME_CONTROLBAR';
export const CHANGE_BRIGHTNESS:'CHANGE_BRIGHTNESS' = 'CHANGE_BRIGHTNESS';
export const CHANGE_BRIGHTNESS_CONTROLBAR:'CHANGE_BRIGHTNESS_CONTROLBAR' = 'CHANGE_BRIGHTNESS_CONTROLBAR';
export const CHANGE_WIFI:'CHANGE_WIFI' = 'CHANGE_WIFI';
export const CHANGE_WIFI_CONTROLBAR:'CHANGE_WIFI_CONTROLBAR' = 'CHANGE_WIFI_CONTROLBAR';
export const CHANGE_BLUETOOTH:'CHANGE_BLUETOOTH' = 'CHANGE_BLUETOOTH';
export const CHANGE_BLUETOOTH_CONTROLBAR:'CHANGE_BLUETOOTH_CONTROLBAR' = 'CHANGE_BLUETOOTH_CONTROLBAR';
export const CHANGE_FLIGHTMODE:'CHANGE_FLIGHTMODE' = 'CHANGE_FLIGHTMODE';
export const CHANGE_FOCUSMODE:'CHANGE_FOCUSMODE' = 'CHANGE_FOCUSMODE';
export const CHANGE_HOTSPOT:'CHANGE_HOTSPOT' = 'CHANGE_HOTSPOT';
export const CHANGE_VPN:'CHANGE_VPN' = 'CHANGE_VPN';
export const CHANGE_WALLAPER:'CHANGE_WALLAPER' = 'CHANGE_WALLAPER';